export const categories = [
  {
    slug: 'it-programming',
    name: 'IT编程技术',
    description: '掌握前沿编程技术，从前端开发到人工智能，系统化提升技术实力',
    icon: 'ri-code-s-slash-line',
    courseCount: 48,
  },
  {
    slug: 'design-creative',
    name: '设计创意',
    description: 'UI设计、平面设计、视频剪辑等创意技能，释放你的创造力',
    icon: 'ri-brush-line',
    courseCount: 36,
  },
  {
    slug: 'business-management',
    name: '商业管理',
    description: '项目管理、市场营销、财务分析，全面提升商业思维与管理能力',
    icon: 'ri-line-chart-line',
    courseCount: 42,
  },
  {
    slug: 'language-learning',
    name: '语言学习',
    description: '英语、日语、商务口语，多语言能力助你在职场中脱颖而出',
    icon: 'ri-global-line',
    courseCount: 30,
  },
  {
    slug: 'vocational-skills',
    name: '职业技能',
    description: '办公软件、数据分析、演讲表达，实用技能快速提升工作效率',
    icon: 'ri-tools-line',
    courseCount: 55,
  },
  {
    slug: 'certification',
    name: '资格证书',
    description: 'PMP、CPA、心理咨询师等权威认证备考课程，助你一次通关',
    icon: 'ri-award-line',
    courseCount: 28,
  },
];

export const allCourses = [
  {
    id: 1,
    slug: 'python-data-analysis',
    title: 'Python数据分析实战',
    category: 'it-programming',
    description: '从零基础到数据分析专家，系统掌握Python在数据处理、可视化和机器学习中的应用。课程包含大量真实案例和项目实战。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20coding%20workspace%20with%20laptop%20displaying%20Python%20code%20and%20data%20charts%2C%20minimalist%20desk%20setup%20with%20warm%20lighting%2C%20professional%20atmosphere%2C%20educational%20technology%20theme%2C%20soft%20neutral%20background&width=800&height=600&seq=course-python-01&orientation=landscape',
    price: 299,
    originalPrice: 599,
    duration: '12周',
    students: 3842,
    rating: 4.8,
    level: '初级到中级',
    instructor: '张明远',
    highlights: ['200+实战案例', '终身回看', '社群答疑'],
  },
  {
    id: 2,
    slug: 'web-fullstack',
    title: 'Web全栈开发工程师',
    category: 'it-programming',
    description: '从前端到后端，全面掌握React、Node.js、数据库等技术栈，成为企业争抢的全栈工程师。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20web%20development%20workspace%20with%20dual%20monitors%20showing%20React%20code%20and%20website%20preview%2C%20clean%20minimalist%20desk%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20environment&width=800&height=600&seq=course-web-02&orientation=landscape',
    price: 399,
    originalPrice: 799,
    duration: '16周',
    students: 2156,
    rating: 4.9,
    level: '中级',
    instructor: '李思远',
    highlights: ['项目驱动教学', '企业级实战', '就业指导'],
  },
  {
    id: 3,
    slug: 'ui-ux-design',
    title: 'UI/UX设计全链路',
    category: 'design-creative',
    description: '从用户研究到高保真原型，系统掌握产品设计全流程。学习Figma、用户研究方法论、交互设计原则。',
    image: 'https://readdy.ai/api/search-image?query=Creative%20design%20studio%20with%20large%20monitor%20showing%20UI%20design%20mockups%20in%20Figma%2C%20color%20palette%20swatches%20on%20desk%2C%20minimalist%20workspace%2C%20warm%20natural%20light%2C%20professional%20creative%20environment&width=800&height=600&seq=course-uiux-03&orientation=landscape',
    price: 349,
    originalPrice: 699,
    duration: '10周',
    students: 1823,
    rating: 4.7,
    level: '入门到进阶',
    instructor: '王悦然',
    highlights: ['作品集打造', '真实项目', '1v1指导'],
  },
  {
    id: 4,
    slug: 'project-management-pmp',
    title: 'PMP项目管理认证',
    category: 'business-management',
    description: '系统学习PMBOK知识体系，覆盖PMP考试全部考点，模拟题库+真题解析，助力一次通过认证。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20room%20with%20project%20timeline%20charts%20on%20whiteboard%2C%20modern%20office%20setting%2C%20clean%20minimalist%20interior%2C%20warm%20ambient%20lighting%2C%20corporate%20training%20atmosphere&width=800&height=600&seq=course-pmp-04&orientation=landscape',
    price: 499,
    originalPrice: 999,
    duration: '8周',
    students: 4218,
    rating: 4.9,
    level: '中高级',
    instructor: '陈志远',
    highlights: ['官方教材', '模拟考试', '不过退费'],
  },
  {
    id: 5,
    slug: 'business-english',
    title: '商务英语实战',
    category: 'language-learning',
    description: '聚焦职场场景，涵盖邮件写作、会议演讲、商务谈判等核心技能，快速提升商务英语应用能力。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20language%20learning%20environment%20with%20headphones%20and%20notebook%20on%20clean%20desk%2C%20English%20textbooks%20and%20digital%20tablet%2C%20warm%20natural%20light%20from%20window%2C%20minimalist%20study%20setting%2C%20professional%20atmosphere&width=800&height=600&seq=course-english-05&orientation=landscape',
    price: 259,
    originalPrice: 499,
    duration: '14周',
    students: 5671,
    rating: 4.6,
    level: '初级到中级',
    instructor: 'Sarah Johnson',
    highlights: ['外教授课', '场景模拟', '口语陪练'],
  },
  {
    id: 6,
    slug: 'excel-advanced',
    title: 'Excel高级数据分析',
    category: 'vocational-skills',
    description: '掌握数据透视表、VBA宏、Power Query等高级功能，成为办公室数据处理高手。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20office%20desk%20with%20laptop%20displaying%20Excel%20spreadsheets%20and%20charts%2C%20professional%20workspace%2C%20warm%20ambient%20lighting%2C%20minimalist%20setting%2C%20data%20analysis%20theme&width=800&height=600&seq=course-excel-06&orientation=landscape',
    price: 199,
    originalPrice: 399,
    duration: '6周',
    students: 8934,
    rating: 4.8,
    level: '中级',
    instructor: '赵伟',
    highlights: ['实战案例', '模板赠送', '社群答疑'],
  },
  {
    id: 7,
    slug: 'cpa-accounting',
    title: 'CPA注册会计师',
    category: 'certification',
    description: '全面覆盖CPA六科考点，资深讲师团队精心打磨课程体系，配合真题演练和考前冲刺。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20accounting%20study%20environment%20with%20financial%20reports%20and%20calculator%20on%20desk%2C%20clean%20modern%20office%2C%20warm%20lighting%2C%20focused%20studying%20atmosphere%2C%20certification%20exam%20preparation%20theme&width=800&height=600&seq=course-cpa-07&orientation=landscape',
    price: 599,
    originalPrice: 1299,
    duration: '20周',
    students: 3120,
    rating: 4.7,
    level: '中高级',
    instructor: '刘芳',
    highlights: ['六科全覆盖', '真题题库', '考前冲刺'],
  },
  {
    id: 8,
    slug: 'ai-machine-learning',
    title: '人工智能与机器学习',
    category: 'it-programming',
    description: '系统学习机器学习核心算法、深度学习框架，从理论到实践全面掌握AI技术。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20neural%20network%20visualization%20on%20screen%2C%20clean%20modern%20workspace%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20environment%2C%20machine%20learning%20theme&width=800&height=600&seq=course-ai-08&orientation=landscape',
    price: 449,
    originalPrice: 899,
    duration: '18周',
    students: 1654,
    rating: 4.8,
    level: '中级',
    instructor: '张明远',
    highlights: ['GPU实战', '企业项目', '论文导读'],
  },
  {
    id: 9,
    slug: 'graphic-design',
    title: '平面设计大师班',
    category: 'design-creative',
    description: '从Photoshop到Illustrator，系统掌握平面设计核心技能，打造专业级作品集。',
    image: 'https://readdy.ai/api/search-image?query=Creative%20design%20studio%20with%20graphic%20design%20posters%20on%20wall%2C%20drawing%20tablet%20and%20color%20swatches%20on%20desk%2C%20minimalist%20workspace%2C%20warm%20natural%20lighting%2C%20artistic%20atmosphere&width=800&height=600&seq=course-graphic-09&orientation=landscape',
    price: 329,
    originalPrice: 649,
    duration: '12周',
    students: 2340,
    rating: 4.6,
    level: '零基础',
    instructor: '王悦然',
    highlights: ['作品集指导', '商业案例', '接单技巧'],
  },
  {
    id: 10,
    slug: 'marketing-digital',
    title: '数字营销全攻略',
    category: 'business-management',
    description: '掌握SEO、SEM、社交媒体营销、内容营销等全渠道数字营销策略。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20marketing%20dashboard%20on%20large%20monitor%20with%20analytics%20charts%2C%20clean%20workspace%2C%20professional%20office%20setting%2C%20warm%20lighting%2C%20marketing%20strategy%20theme&width=800&height=600&seq=course-marketing-10&orientation=landscape',
    price: 279,
    originalPrice: 549,
    duration: '10周',
    students: 3456,
    rating: 4.7,
    level: '入门到进阶',
    instructor: '陈志远',
    highlights: ['实战项目', '工具教学', '行业案例'],
  },
  {
    id: 11,
    slug: 'japanese-business',
    title: '日语商务沟通',
    category: 'language-learning',
    description: '从五十音到商务会话，系统掌握日语听说读写，助力职场中日商务交流。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20language%20learning%20environment%20with%20textbooks%20and%20digital%20tablet%20showing%20kanji%2C%20minimalist%20study%20desk%2C%20warm%20natural%20light%2C%20clean%20and%20organized%20setting&width=800&height=600&seq=course-japanese-11&orientation=landscape',
    price: 289,
    originalPrice: 569,
    duration: '16周',
    students: 2789,
    rating: 4.8,
    level: '零基础',
    instructor: '田中花子',
    highlights: ['日教授课', 'JLPT备考', '文化融入'],
  },
  {
    id: 12,
    slug: 'ppt-presentation',
    title: 'PPT演讲演示高手',
    category: 'vocational-skills',
    description: '从PPT设计到演讲表达，全面提升你的职场汇报与演示能力，让你的每一次展示都令人印象深刻。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20presentation%20setup%20with%20laptop%20displaying%20beautiful%20slides%2C%20minimalist%20conference%20room%2C%20professional%20atmosphere%2C%20warm%20lighting%2C%20business%20presentation%20theme&width=800&height=600&seq=course-ppt-12&orientation=landscape',
    price: 169,
    originalPrice: 349,
    duration: '4周',
    students: 10234,
    rating: 4.9,
    level: '所有级别',
    instructor: '赵伟',
    highlights: ['模板赠送', '演讲技巧', '实战演练'],
  },
];

export const allArticles = [
  {
    id: 1,
    slug: 'career-change-guide-2026',
    title: '2026年职场转型指南：如何选择适合你的在线课程',
    category: 'career',
    excerpt: '面对快速变化的职场环境，越来越多的成年人选择通过在线学习实现职业转型。本文为你详细分析如何根据自身情况选择最合适的在线课程。',
    content: `在当今快速变化的职场环境中，职业转型已经成为越来越多职场人士的必然选择。据最新调查数据显示，超过65%的职场人士在未来三年内有职业转型的打算，而在线学习成为了他们实现这一目标的首选途径。

<h3>一、为什么选择在线学习进行职业转型</h3>

<p>在线学习具有传统教育无法比拟的灵活性。对于已经有工作和家庭责任的成年人来说，能够根据自己的时间安排学习是最大的优势。你可以在通勤路上观看课程视频，在午休时间完成练习，在周末进行项目实战。</p>

<p>此外，在线课程通常更加聚焦实操技能，课程内容紧跟行业需求，学习后可以直接应用到工作中。相比传统学历教育，在线课程的学习周期更短，性价比更高。</p>

<h3>二、如何评估自己的职业转型方向</h3>

<p>在选择转型方向之前，建议你先做一次全面的自我评估：</p>

<p><strong>1. 兴趣与热情：</strong>你对哪个领域真正感兴趣？兴趣是最好的老师，选择你热爱的方向会让学习过程更加愉快和持久。</p>

<p><strong>2. 现有技能可迁移性：</strong>你目前掌握哪些可以迁移到新领域的技能？例如，如果你擅长逻辑思维和问题解决，转向编程领域会更加顺利。</p>

<p><strong>3. 市场需求：</strong>你选择的方向是否有足够多的就业机会？可以通过招聘网站、行业报告了解市场需求情况。</p>

<p><strong>4. 薪资预期：</strong>转型后的薪资水平是否符合你的预期？不同行业和岗位的薪资差异很大，需要提前了解清楚。</p>

<h3>三、选择合适的在线课程</h3>

<p>确定转型方向后，选择课程时建议关注以下几点：</p>

<p><strong>课程体系完整性：</strong>好的课程应该有清晰的学习路径，从基础到进阶循序渐进。</p>

<p><strong>实战项目：</strong>理论加实践才能真正掌握技能。选择包含大量实战项目的课程。</p>

<p><strong>讲师背景：</strong>了解讲师的行业经验和教学能力，好的讲师能让学习事半功倍。</p>

<p><strong>学员评价：</strong>参考其他学员的真实评价，了解课程的实际效果。</p>

<p><strong>就业支持：</strong>一些优质平台会提供简历指导、模拟面试等就业支持服务。</p>

<h3>四、制定学习计划并坚持执行</h3>

<p>选择了课程只是第一步，制定合理的学习计划并坚持下去才是成功的关键。建议每周固定安排学习时间，设定阶段性小目标，保持学习的连续性和动力。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Professional%20adult%20studying%20online%20with%20laptop%20in%20modern%20home%20office%2C%20warm%20natural%20lighting%2C%20clean%20minimalist%20environment%2C%20focused%20learning%20atmosphere%2C%20career%20development%20theme&width=1200&height=600&seq=article-career-01&orientation=landscape',
    date: '2026-07-28',
    author: '张明远',
    readTime: '8分钟',
  },
  {
    id: 2,
    slug: 'python-beginner-roadmap',
    title: '零基础学Python：一份完整的自学路线图',
    category: 'it-programming',
    excerpt: 'Python作为最受欢迎的编程语言之一，是很多人编程入门的第一选择。本文为零基础学员提供一份详细的自学路线图。',
    content: `<p>Python凭借其简洁的语法和强大的生态系统，成为了全球最受欢迎的编程语言之一。无论你是想转行做开发、提升数据分析能力，还是对人工智能感兴趣，Python都是一个绝佳的起点。</p>

<h3>第一阶段：基础语法（2-3周）</h3>
<p>学习Python的基础语法，包括变量、数据类型、条件判断、循环、函数等核心概念。这个阶段的目标是能够独立编写简单的程序。</p>

<h3>第二阶段：进阶编程（3-4周）</h3>
<p>深入学习面向对象编程、文件操作、异常处理、模块和包的使用。开始接触一些常用的Python标准库。</p>

<h3>第三阶段：专业方向选择</h3>
<p>根据自己的兴趣和职业规划，选择一个专业方向深入学习：Web开发、数据分析、人工智能、自动化测试等。</p>

<h3>第四阶段：项目实战</h3>
<p>通过实际项目巩固所学知识。建议从简单项目开始，逐步挑战更复杂的项目。这个阶段是技能提升最快的时期。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Clean%20coding%20workspace%20with%20Python%20textbook%20and%20laptop%20showing%20code%2C%20minimalist%20desk%20setup%2C%20warm%20natural%20lighting%2C%20programming%20learning%20environment&width=1200&height=600&seq=article-python-02&orientation=landscape',
    date: '2026-07-20',
    author: '李思远',
    readTime: '6分钟',
  },
  {
    id: 3,
    slug: 'pmp-exam-preparation',
    title: 'PMP备考全攻略：3个月高效通过认证',
    category: 'business-management',
    excerpt: 'PMP认证是项目管理领域含金量最高的证书之一。本文分享一套经过验证的3个月备考方案，帮助你高效通过考试。',
    content: `<p>PMP认证是项目管理领域含金量最高的证书之一，对于职业发展有着显著的推动作用。以下是一套经过验证的3个月备考方案。</p>

<h3>第一个月：知识体系学习</h3>
<p>系统学习PMBOK指南的知识体系，理解五大过程组和十大知识领域。每天保持2-3小时的学习时间，周末进行知识回顾和总结。</p>

<h3>第二个月：强化练习</h3>
<p>开始大量做题，通过题目巩固知识点。建议每天做50-100道题，并认真分析错题原因。同时开始整理自己的知识框架和记忆要点。</p>

<h3>第三个月：冲刺模拟</h3>
<p>进行全真模拟考试，训练做题速度和心态。查漏补缺，重点攻克薄弱环节。考前一周调整状态，保持良好作息。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Professional%20project%20management%20study%20materials%20with%20PMBOK%20guide%20and%20notes%20on%20desk%2C%20clean%20workspace%2C%20warm%20lighting%2C%20focused%20study%20environment%2C%20certification%20preparation%20theme&width=1200&height=600&seq=article-pmp-03&orientation=landscape',
    date: '2026-07-15',
    author: '陈志远',
    readTime: '7分钟',
  },
  {
    id: 4,
    slug: 'remote-work-skills',
    title: '远程办公时代，哪些技能最值得学习？',
    category: 'career',
    excerpt: '远程办公已经成为新常态，掌握正确的技能可以帮助你在远程工作环境中保持高效率和竞争力。',
    content: `<p>远程办公已经成为许多公司和员工的新常态。在这种工作模式下，哪些技能最值得投资学习呢？</p>

<h3>数字协作工具</h3>
<p>熟练掌握Slack、Zoom、Notion、飞书等协作工具，能够高效地进行远程沟通和项目管理。</p>

<h3>自我管理能力</h3>
<p>远程工作对自律性要求更高。学习时间管理、目标管理方法，建立高效的个人工作系统。</p>

<h3>数字化技能</h3>
<p>数据分析、基础编程、数字化营销等技能在远程工作时代更加重要。这些技能让你能够独立完成更多任务。</p>

<h3>跨文化沟通</h3>
<p>远程团队往往分布在全球各地，跨文化沟通能力成为必备软实力。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20office%20setup%20with%20laptop%20and%20dual%20monitors%2C%20minimalist%20workspace%20with%20plants%2C%20warm%20natural%20lighting%20from%20window%2C%20professional%20remote%20work%20environment&width=1200&height=600&seq=article-remote-04&orientation=landscape',
    date: '2026-07-08',
    author: '赵伟',
    readTime: '5分钟',
  },
  {
    id: 5,
    slug: 'ui-design-trends-2026',
    title: '2026年UI设计趋势：设计师必知的5大方向',
    category: 'design-creative',
    excerpt: '了解最新的UI设计趋势对于设计师至关重要。本文总结了2026年最具影响力的5个设计方向。',
    content: `<p>设计行业的变化从未停止，2026年UI设计领域迎来了多个引人注目的新趋势。作为设计师，了解并掌握这些趋势将帮助你在职场中保持竞争力。</p>

<h3>AI驱动的个性化设计</h3>
<p>人工智能正在深刻改变UI设计的方式。从自动生成设计稿到智能适配用户偏好，AI工具已经成为设计师的得力助手。</p>

<h3>沉浸式3D交互</h3>
<p>随着硬件性能的提升和Web技术的进步，3D元素在界面设计中的应用越来越广泛，为用户带来更加沉浸的体验。</p>

<h3>极简主义回归</h3>
<p>在信息过载的时代，极简设计帮助用户聚焦核心内容。2026年的极简不仅仅是"少即是多"，更强调"恰到好处"。</p>

<h3>包容性设计</h3>
<p>无障碍设计不再是可选项，而是标配。设计师需要考虑不同能力用户的使用体验，让产品更加包容。</p>

<h3>动态视觉叙事</h3>
<p>微交互和动效不再是装饰，而是引导用户、传递信息的重要手段。精心设计的动效可以大幅提升用户体验。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20UI%20design%20workspace%20with%20design%20trends%20moodboard%20on%20wall%2C%20minimalist%20desk%20with%20drawing%20tablet%2C%20warm%20creative%20studio%20lighting%2C%20design%20inspiration%20environment&width=1200&height=600&seq=article-ui-05&orientation=landscape',
    date: '2026-06-30',
    author: '王悦然',
    readTime: '6分钟',
  },
  {
    id: 6,
    slug: 'lifelong-learning-mindset',
    title: '终身学习：成年人如何培养持续学习的习惯',
    category: 'career',
    excerpt: '在知识快速迭代的时代，终身学习已经从选择变成了必需。本文探讨如何培养和保持持续学习的习惯。',
    content: `<p>在知识更新速度不断加快的今天，终身学习已经成为每个人的必修课。但是，如何在繁忙的工作和生活中坚持学习呢？</p>

<h3>建立学习的内在动力</h3>
<p>找到学习的意义和乐趣，而不是把学习当作任务。选择你真正感兴趣的领域开始，让学习成为一种享受而非负担。</p>

<h3>微学习策略</h3>
<p>每天学习15-30分钟，比每周集中学习一整天效果更好。利用碎片时间，把学习融入日常生活。</p>

<h3>建立学习社群</h3>
<p>找到志同道合的学习伙伴，互相鼓励和监督。加入学习社群可以大大提高学习的持续性和效果。</p>

<h3>以教为学</h3>
<p>把你学到的东西教给别人，这是巩固知识最有效的方式。写博客、录视频、做分享都是很好的方式。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20bookshelf%20and%20comfortable%20armchair%2C%20warm%20natural%20lighting%2C%20peaceful%20learning%20atmosphere%2C%20minimalist%20interior%2C%20lifelong%20learning%20theme&width=1200&height=600&seq=article-learning-06&orientation=landscape',
    date: '2026-06-22',
    author: '张明远',
    readTime: '5分钟',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '王小明',
    role: '前端开发工程师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20male%20professional%20in%20business%20casual%20attire%2C%20clean%20neutral%20background%2C%20friendly%20expression%2C%20warm%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '作为一名零基础的转行者，通过这个平台的Python课程，我只用了4个月就成功转行成为前端开发工程师。课程内容系统全面，项目实战非常有帮助！',
    rating: 5,
    course: 'Web全栈开发工程师',
  },
  {
    id: 2,
    name: '李婷',
    role: '产品经理',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20female%20professional%20in%20modern%20office%20attire%2C%20clean%20neutral%20background%2C%20confident%20expression%2C%20warm%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: 'PMP课程帮助我系统掌握了项目管理方法论，顺利通过了认证考试。老师的讲解深入浅出，即使是复杂的概念也能轻松理解。',
    rating: 5,
    course: 'PMP项目管理认证',
  },
  {
    id: 3,
    name: '张伟',
    role: '数据分析师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20male%20in%20smart%20casual%2C%20clean%20neutral%20background%2C%20friendly%20smile%2C%20warm%20studio%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: 'Excel高级课程让我的工作效率提升了至少3倍，领导对我的数据分析能力赞不绝口。课程实用性极强，学完就能用！',
    rating: 5,
    course: 'Excel高级数据分析',
  },
];

export const faqs = [
  {
    question: '课程购买后可以学习多久？',
    answer: '所有课程购买后均支持终身回看，你可以根据自己的节奏自由安排学习时间，不受任何时间限制。',
  },
  {
    question: '是否有试听课程？',
    answer: '是的，每门课程都提供免费的试听章节，你可以在购买前先体验课程内容和讲师风格，确保课程适合你的学习需求。',
  },
  {
    question: '学习过程中遇到问题怎么办？',
    answer: '我们为每门课程配备了专属学习社群和答疑服务。你可以在社群中与同学讨论，也可以直接向讲师提问，通常24小时内会得到回复。',
  },
  {
    question: '课程是否提供证书？',
    answer: '完成课程学习并通过考核后，你将获得平台颁发的结业证书。部分认证类课程（如PMP）还会提供官方考试的备考指导。',
  },
  {
    question: '可以在手机上学习吗？',
    answer: '当然可以！我们的学习平台支持全终端适配，你可以在手机、平板、电脑上随时随地学习，学习进度会自动同步。',
  },
  {
    question: '如果不满意可以退款吗？',
    answer: '我们提供7天无理由退款保障。如果购买后7天内对课程不满意，可以申请全额退款，无需任何理由。',
  },
];

export const stats = [
  { label: '在线课程', value: '500+', icon: 'ri-play-circle-line' },
  { label: '累计学员', value: '50万+', icon: 'ri-user-line' },
  { label: '合作讲师', value: '200+', icon: 'ri-team-line' },
  { label: '课程好评率', value: '98%', icon: 'ri-heart-line' },
];